<div class="feature" *ngFor="let feature of features">
  <div class="feature-description">
    <h3>{{ feature.title }}</h3>
    <p>{{ feature.description }}</p>
  </div>

  <div class="feature-image">
    <img src="/assets/images/{{ feature.image }}" alt="App Screenshot" class="{{ feature.class }}">
  </div>
</div>
